import React, { Component } from "react";

class Donate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      fatherName: "",
      studentEmail: "",
      mobileNumber: "",
      whatsappNumber: "",
      dob: "",
      gender: "",
      address: "",
      course: "",
      batchType: "",
      siteLanguage: "",
    };
  }

  componentDidMount() {
    const siteLanguage = localStorage.getItem("siteLanguage") || "en";
    this.setState({ siteLanguage });
  }

  // Handle input changes
  handleChange = (e) => {
    this.setState({});
  };

  render() {
    // const {} = this.state;

    return (
      <div
        className={`container-fluid contact py-3 ${
          this.state.siteLanguage === "ur" ? " direction-rtl" : ""
        }`}
      >
        <div className="container">
          <div className="text-center mx-auto mb-3">
            <p className="fs-5 text-uppercase text-primary">
              {this.state.siteLanguage === "ur" ? (
                <>ہمیں عطیہ دیں</>
              ) : this.state.siteLanguage === "ro" ? (
                <>Donate Us</>
              ) : (
                <>Donate Us</>
              )}
            </p>
            <h1 className="mb-4 text-capitalize">
              {this.state.siteLanguage === "ur" ? (
                <>آپ کے عطیات امید کی ایک کرن ہے</>
              ) : this.state.siteLanguage === "ro" ? (
                <>Aap Ke Atiyat Umeed Ki Ek Kiran Hai </>
              ) : (
                <>Your donations are a ray of hope.</>
              )}
            </h1>
          </div>

          <div className="col-lg-10 container bg-white p-4 rounded-3 shadow">

              <div className="col-lg-5 pb-3 m-auto">
                <img
                  src="https://lqe-assets.learnquraneasily.in/1747976002411_donate_img.jpg"
                  alt="Donation Support"
                  className="img-fluid rounded-2 shadow-3"
                />
              </div>

              <div className="text-capitalize">
                <p className="text-center">
                  {this.state.siteLanguage === "ur" ? (
                    <>
                      آپ کے دیے گیے عطیات کسی بھی نیک مقصد کے لیے استعمال ہو
                      سکتے ہیں— چاہے وہ دین کی خدمت ہو، فلاحِ انسانیت، اصلاحِ
                      معاشرہ، یا روحانی ترقی۔ یہ نہ صرف ضرورت مندوں کی مدد کرتا
                      ہے بلکہ معاشرے میں خیر، محبت اور ایمان کی روشنی پھیلاتا
                      ہے۔ ہر عطیات ایک صدقہ جاریہ ہے، جو دلوں کو جوڑتا ہے،
                      زندگیوں کو سنوارتا ہے، اور آخرت کا ذخیرہ بنتا ہے۔
                    </>
                  ) : this.state.siteLanguage === "ro" ? (
                    <>
                      Aap ke diye gaye Atiyat kisi bhi naik maqsad ke liye
                      istemal ho sakte hain —chaahe woh deen ki khidmat ho,
                      falaah-e-insaniyat, islaah-e-muashra, ya roohani taraqqi.
                      <br />
                      <br />
                      Yeh na sirf zarurat mandon ki madad karta hai balkay
                      muashray mein khair, mohabbat aur imaan ki roshni phailata
                      hai.
                      <br />
                      <br />
                      Har atiyat ek sadqa-e-jaariya hai, jo dilon ko jorta hai,
                      zindagiyon ko sanwarta hai, aur aakhirat ka zakheera banta
                      hai.
                    </>
                  ) : (
                    <>
                      The contributions you give can be used for any noble
                      cause—whether it’s serving the faith, helping humanity,
                      reforming society, or promoting spiritual growth. They not
                      only support those in need but also spread goodness, love,
                      and the light of faith throughout the community.
                      <br />
                      <br />
                      Every donation is a form of ongoing charity (Sadaqah
                      Jariyah), connecting hearts, uplifting lives, and becoming
                      a treasure for the Hereafter.
                    </>
                  )}
                </p>
              </div>
              
            {/* QR Section */}
            <div className="d-flex flex-wrap align-items-center justify-content-center my-4">
              <div className="col-lg-4">
              <img
                src="https://lqe-assets.learnquraneasily.in/1748244319313_qr_code.jpg"
                alt="QR Code"
                className="img-fluid mb-3 mb-md-0 br-10 shadow"
              />
              </div>
              
              <div className="col-lg-8 text-container px-lg-3 lh-base">
                <h6>
                  {this.state.siteLanguage === "ur"
                    ? "اکاؤنٹ ہولڈر کا نام"
                    : this.state.siteLanguage === "ro"
                    ? "Account Holder Name"
                    : "Account Holder Name"}{" "}
                  : <strong>Md Wasim Aktar</strong>
                </h6>
                <h6>
                  {this.state.siteLanguage === "ur"
                    ? "اکاؤنٹ نمبر"
                    : this.state.siteLanguage === "ro"
                    ? "Account Number"
                    : "Account Number"}{" "}
                  : <strong>50100575268651</strong>
                </h6>
                 <h6>
                  {this.state.siteLanguage === "ur"
                    ? "آئی ایف ایس سی کوڈ"
                    : this.state.siteLanguage === "ro"
                    ? "IFSC Code"
                    : "IFSC Code"}{" "}
                  : <strong>HDFC0002747</strong>
                </h6>
                <h6>
                  {this.state.siteLanguage === "ur"
                    ? "برانچ"
                    : this.state.siteLanguage === "ro"
                    ? "Branch"
                    : "Branch"}{" "}
                  : <strong>Islampur</strong>
                </h6>
                <h6>
                  {this.state.siteLanguage === "ur"
                    ? "(فون پے / گوگل پے / پے ٹی ایم) کے ذریعے UPI ادائیگی"
                    : this.state.siteLanguage === "ro"
                    ? "For UPI Payments (PhonePe / Google Pay / Paytm)"
                    : "For UPI Payments (PhonePe / Google Pay / Paytm)"}{" "}
                  : <strong>7296084826</strong>
                </h6>
                <h6>
                  {this.state.siteLanguage === "ur"
                    ? "UPI آئی ڈی"
                    : this.state.siteLanguage === "ro"
                    ? "UPI ID"
                    : "UPI ID"}{" "}
                  : <strong>mdwasimaktar711-2@okhdfcbank</strong>
                </h6>
                <p>
                  {this.state.siteLanguage === "ur"
                    ? "آپ فون پے، گوگل پے یا پے ٹی ایم جیسے کسی بھی UPI ایپ سے ادائیگی کر سکتے ہیں۔"
                    : this.state.siteLanguage === "ro"
                    ? "You can send payments using any UPI app like PhonePe, Google Pay, or Paytm."
                    : "You can send payments using any UPI app like PhonePe, Google Pay, or Paytm."}
                </p>
                <h6>
                  {this.state.siteLanguage === "ur"
                    ? "QR کوڈ اسکین کریں اور ادائیگی کریں"
                    : this.state.siteLanguage === "ro"
                    ? "Scan & Pay using QR Code"
                    : "Scan & Pay using QR Code"}
                </h6>
                <p>
                  {this.state.siteLanguage === "ur"
                    ? "براہ راست ادائیگی کرنے کے لیے نیچے دیے گئے QR کوڈ کو اسکین کریں۔"
                    : this.state.siteLanguage === "ro"
                    ? "You can also scan the QR code below to make a direct payment."
                    : "You can also scan the QR code below to make a direct payment."}
                </p>

                 {/* <h5>
                  {this.state.siteLanguage === "ur"
                    ? "موبائل نمبر"
                    : this.state.siteLanguage === "ro"
                    ? "Mobile Number"
                    : "Mobile Number"}{" "}
                  : <strong>7296084826</strong>
                </h5> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Donate;
